import { FeaturedOnRow } from './styled';
import type { HomeCms } from '@/components/OurPlans/query';

export const FeaturedOn = ({ gallery, title }: HomeCms) => {
  return (
    <FeaturedOnRow justifyContent="space-around">
      <p>{title}</p>
      {gallery?.map((image) => {
        return <img src={image.url} key={image.title} alt={image.title} />;
      })}
    </FeaturedOnRow>
  );
};
